// Handle Video
const handleVideo = () => {
  const video = document.querySelector("#front__video-element");
  const button = document.querySelector("#front__video-button");

  button.addEventListener("click", () => {
    video.play();
    button.style.display = "none";
  });

  video.addEventListener("click", () => {
    if (video.paused) {
      video.play();
      button.style.display = "none";
    } else {
      video.pause();
      button.style.display = "block";
    }
  });
};
document.addEventListener("DOMContentLoaded", () => {
  handleVideo();
});


function initRankingSlider() {
    const rankingSlider = document.querySelector('.js-ranking-slider')
    if (rankingSlider && typeof Swiper !== 'undefined') {
        new Swiper(rankingSlider, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            speed: 1600,
            autoplay: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initRankingSlider()
})

function initNewArrivalSlider() {
    const newArrivalSlider = document.querySelector('.js-new-arrival-slider')
    if (newArrivalSlider && typeof Swiper !== 'undefined') {
        new Swiper(newArrivalSlider, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            loop: true,
            speed: 1600,
            autoplay: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                1025: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initNewArrivalSlider()
})